import type { Static } from 'runtypes';
import { Null, Number, Record, String } from 'runtypes';

enum LoginInfoMessageEnum {
  EXPIRED = 'EXPIRED',
  CLOSED = 'CLOSED',
  UNKNOWN = 'UNKNOWN',
  SIGNED_OUT = 'SIGNED_OUT',
  DEACTIVATED = 'DEACTIVATED',
  CANCELED_PW_RESET = 'CANCELED_PW_RESET',
}

const ClickstreamSessionCacheRuntype = Record({
  startDateTime: String,
  userId: Number,
  userUuid: String.Or(Null).optional(),
});

type ClickstreamSessionCache = Static<typeof ClickstreamSessionCacheRuntype>;

export { ClickstreamSessionCacheRuntype, LoginInfoMessageEnum };
export type { ClickstreamSessionCache };
